import { config as envConfig } from 'ENV_CONFIG';
import { services } from '~/ocab-services/services.constant';

export const getAppointmentsDetails = () => ({
  journey: envConfig.services[services.LINGERIE.name]?.analyticsJourneyName,
  branchId: '',
});
